import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import fetch from '../../fetch.js';
import { baseUrl, customHeaders, commsHeader, indianProjectsBaseURL, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';

import { VENDOR_DASHBOARD_DATA, VENDOR_DASHBOARD_DATA_SUCCESS, VENDOR_DASHBOARD_DATA_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* getVendorDashboardData({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${uaeProjectsBaseURL}/vendor/v1/dashboard`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({ type: VENDOR_DASHBOARD_DATA_SUCCESS, payload: response?.data });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({ type: VENDOR_DASHBOARD_DATA_ERROR, payload: response?.data?.message });
    }
  } catch (error) {
    yield put({ type: VENDOR_DASHBOARD_DATA_ERROR, payload: error });
  }
}

export function* watchGetVendorDashboardData() {
  yield takeEvery(VENDOR_DASHBOARD_DATA, getVendorDashboardData);
}

function* getVendorsDashboardDataSaga() {
  yield all([fork(watchGetVendorDashboardData)]);
}

export default getVendorsDashboardDataSaga;
